import _objectSpread from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _slicedToArray from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "C:\\Users\\zysio\\Documents\\Work\\GoodKarma\\MintPage\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

var _errorMessages;

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var DEFAULT_PATH = "m/44'/60'/0'/0/0";
var DEFAULT_BASE_PATHS = [{
  label: 'Ethereum Mainnet',
  value: DEFAULT_PATH
}];
var assets = [{
  label: 'ETH'
}];
var ERROR_BUSY = 'busy';
var ERROR_PAIRING = 'pairing';
var errorMessages = (_errorMessages = {}, _defineProperty(_errorMessages, ERROR_BUSY, "Your KeepKey is currently connected to another application.\n  Please close any other browser tabs or applications that may be connected to your device and try again."), _defineProperty(_errorMessages, ERROR_PAIRING, 'There was an error pairing the device. Please disconnect and reconnect the device and try again.'), _errorMessages);

function keepkey() {
  var getIcon = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return import('./icon.js');

            case 2:
              return _context.abrupt("return", _context.sent.default);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getIcon() {
      return _ref.apply(this, arguments);
    };
  }();

  return function () {
    var accounts;
    return {
      label: 'KeepKey',
      getIcon: getIcon,
      getInterface: function () {
        var _getInterface = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(_ref2) {
          var EventEmitter, chains, _yield$import, WebUSBKeepKeyAdapter, _yield$import2, Keyring, Events, bip32ToAddressNList, addressNListToBIP32, HDWalletErrorType, _yield$import3, accountSelect, createEIP1193Provider, ProviderRpcError, entryModal, bigNumberFieldsToStrings, getHardwareWalletProvider, _yield$import4, utils, _yield$import5, StaticJsonRpcProvider, ethUtil, keyring, keepKeyAdapter, eventEmitter, keepKeyWallet, currentChain, getAccountIdx, getPaths, getAccount, getAllAccounts, ethersProvider, scanAccounts, getAccounts, signMessage, keepKeyProvider, provider;

          return _regeneratorRuntime().wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  EventEmitter = _ref2.EventEmitter, chains = _ref2.chains;
                  _context17.next = 3;
                  return import('@shapeshiftoss/hdwallet-keepkey-webusb');

                case 3:
                  _yield$import = _context17.sent;
                  WebUSBKeepKeyAdapter = _yield$import.WebUSBKeepKeyAdapter;
                  _context17.next = 7;
                  return import('@shapeshiftoss/hdwallet-core');

                case 7:
                  _yield$import2 = _context17.sent;
                  Keyring = _yield$import2.Keyring;
                  Events = _yield$import2.Events;
                  bip32ToAddressNList = _yield$import2.bip32ToAddressNList;
                  addressNListToBIP32 = _yield$import2.addressNListToBIP32;
                  HDWalletErrorType = _yield$import2.HDWalletErrorType;
                  _context17.next = 15;
                  return import('@web3-onboard/common');

                case 15:
                  _yield$import3 = _context17.sent;
                  accountSelect = _yield$import3.accountSelect;
                  createEIP1193Provider = _yield$import3.createEIP1193Provider;
                  ProviderRpcError = _yield$import3.ProviderRpcError;
                  entryModal = _yield$import3.entryModal;
                  bigNumberFieldsToStrings = _yield$import3.bigNumberFieldsToStrings;
                  getHardwareWalletProvider = _yield$import3.getHardwareWalletProvider;
                  _context17.next = 24;
                  return import('ethers');

                case 24:
                  _yield$import4 = _context17.sent;
                  utils = _yield$import4.utils;
                  _context17.next = 28;
                  return import('@ethersproject/providers');

                case 28:
                  _yield$import5 = _context17.sent;
                  StaticJsonRpcProvider = _yield$import5.StaticJsonRpcProvider;
                  _context17.next = 32;
                  return import('ethereumjs-util');

                case 32:
                  ethUtil = _context17.sent;
                  keyring = new Keyring();
                  keepKeyAdapter = WebUSBKeepKeyAdapter.useKeyring(keyring);
                  eventEmitter = new EventEmitter();
                  currentChain = chains[0];
                  keyring.on(['*', '*', Events.DISCONNECT], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            eventEmitter.emit('accountsChanged', []);

                          case 1:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }))); // If the wallet asks for a PIN, open the PIN modal

                  keyring.on(['*', '*', Events.PIN_REQUEST], function () {
                    entryModal('pin', function (val) {
                      return keepKeyWallet.sendPin(val);
                    }, function () {
                      return keepKeyWallet.cancel();
                    });
                  }); // If the wallet asks for a PIN, open the PIN modal

                  keyring.on(['*', '*', Events.PASSPHRASE_REQUEST], function () {
                    entryModal('passphrase', function (val) {
                      return keepKeyWallet.sendPassphrase(val);
                    }, function () {
                      return keepKeyWallet.cancel();
                    });
                  });

                  getAccountIdx = function getAccountIdx(derivationPath) {
                    // Get the account index from the derivation path
                    var _keepKeyWallet$descri = keepKeyWallet.describePath({
                      path: bip32ToAddressNList(derivationPath),
                      coin: 'Ethereum'
                    }),
                        accountIdx = _keepKeyWallet$descri.accountIdx;

                    if (accountIdx === undefined) throw new Error("Could not derive account from path: ".concat(derivationPath));
                    return accountIdx;
                  };

                  getPaths = function getPaths(accountIdx) {
                    // Retrieve the array form of the derivation path for a given account index
                    var _keepKeyWallet$ethGet = keepKeyWallet.ethGetAccountPaths({
                      coin: 'Ethereum',
                      accountIdx: accountIdx
                    }),
                        _keepKeyWallet$ethGet2 = _slicedToArray(_keepKeyWallet$ethGet, 1),
                        paths = _keepKeyWallet$ethGet2[0];

                    return paths;
                  };

                  getAccount = /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref4) {
                      var accountIdx, provider, asset, paths, address, balance;
                      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              accountIdx = _ref4.accountIdx, provider = _ref4.provider, asset = _ref4.asset;
                              paths = getPaths(accountIdx); // Retrieve the address associated with the given account index

                              _context3.next = 4;
                              return keepKeyWallet.ethGetAddress({
                                addressNList: paths.addressNList,
                                showDisplay: false
                              });

                            case 4:
                              address = _context3.sent;
                              _context3.next = 7;
                              return provider.getBalance(address);

                            case 7:
                              balance = _context3.sent;
                              return _context3.abrupt("return", {
                                derivationPath: addressNListToBIP32(paths.addressNList),
                                address: address,
                                balance: {
                                  asset: asset.label,
                                  value: balance
                                }
                              });

                            case 9:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    return function getAccount(_x2) {
                      return _ref5.apply(this, arguments);
                    };
                  }();

                  getAllAccounts = /*#__PURE__*/function () {
                    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref6) {
                      var derivationPath, asset, provider, index, zeroBalanceAccounts, accounts, acc;
                      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              derivationPath = _ref6.derivationPath, asset = _ref6.asset, provider = _ref6.provider;
                              index = getAccountIdx(derivationPath);
                              zeroBalanceAccounts = 0;
                              accounts = []; // Iterates until a 0 balance account is found
                              // Then adds 4 more 0 balance accounts to the array

                            case 4:
                              if (!(zeroBalanceAccounts < 5)) {
                                _context4.next = 12;
                                break;
                              }

                              _context4.next = 7;
                              return getAccount({
                                accountIdx: index,
                                provider: provider,
                                asset: asset
                              });

                            case 7:
                              acc = _context4.sent;

                              if (acc && acc.balance && acc.balance.value && acc.balance.value.isZero()) {
                                zeroBalanceAccounts++;
                                accounts.push(acc);
                              } else {
                                accounts.push(acc); // Reset the number of 0 balance accounts

                                zeroBalanceAccounts = 0;
                              }

                              index++;
                              _context4.next = 4;
                              break;

                            case 12:
                              return _context4.abrupt("return", accounts);

                            case 13:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));

                    return function getAllAccounts(_x3) {
                      return _ref7.apply(this, arguments);
                    };
                  }();

                  scanAccounts = /*#__PURE__*/function () {
                    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref8) {
                      var derivationPath, chainId, asset, accountIdx, account;
                      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              derivationPath = _ref8.derivationPath, chainId = _ref8.chainId, asset = _ref8.asset;

                              if (keepKeyWallet) {
                                _context5.next = 3;
                                break;
                              }

                              throw new Error('Device must be connected before scanning accounts');

                            case 3:
                              currentChain = chains.find(function (_ref10) {
                                var id = _ref10.id;
                                return id === chainId;
                              }) || currentChain;
                              ethersProvider = new StaticJsonRpcProvider(currentChain.rpcUrl); // Checks to see if this is a custom derivation path
                              // If it is then just return the single account

                              if (DEFAULT_BASE_PATHS.find(function (_ref11) {
                                var value = _ref11.value;
                                return value === derivationPath;
                              })) {
                                _context5.next = 17;
                                break;
                              }

                              _context5.prev = 6;
                              accountIdx = getAccountIdx(derivationPath);
                              _context5.next = 10;
                              return getAccount({
                                accountIdx: accountIdx,
                                provider: ethersProvider,
                                asset: asset
                              });

                            case 10:
                              account = _context5.sent;
                              return _context5.abrupt("return", [account]);

                            case 14:
                              _context5.prev = 14;
                              _context5.t0 = _context5["catch"](6);
                              throw new Error('Invalid derivation path');

                            case 17:
                              return _context5.abrupt("return", getAllAccounts({
                                derivationPath: derivationPath,
                                asset: asset,
                                provider: ethersProvider
                              }));

                            case 18:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5, null, [[6, 14]]);
                    }));

                    return function scanAccounts(_x4) {
                      return _ref9.apply(this, arguments);
                    };
                  }();

                  getAccounts = /*#__PURE__*/function () {
                    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.next = 2;
                              return accountSelect({
                                basePaths: DEFAULT_BASE_PATHS,
                                assets: assets,
                                chains: chains,
                                scanAccounts: scanAccounts
                              });

                            case 2:
                              accounts = _context6.sent;

                              if (accounts) {
                                _context6.next = 5;
                                break;
                              }

                              throw new Error('No accounts were found');

                            case 5:
                              if (accounts.length) {
                                eventEmitter.emit('accountsChanged', [accounts[0].address]);
                              }

                              return _context6.abrupt("return", accounts);

                            case 7:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));

                    return function getAccounts() {
                      return _ref12.apply(this, arguments);
                    };
                  }();

                  signMessage = /*#__PURE__*/function () {
                    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(address, message) {
                      var account, derivationPath, accountIdx, _getPaths, addressNList, _yield$keepKeyWallet$, signature;

                      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                        while (1) {
                          switch (_context7.prev = _context7.next) {
                            case 0:
                              if (!(!accounts || !Array.isArray(accounts) || !(accounts.length && accounts.length > 0))) {
                                _context7.next = 2;
                                break;
                              }

                              throw new Error('No account selected. Must call eth_requestAccounts first.');

                            case 2:
                              account = accounts.find(function (account) {
                                return account.address === address;
                              }) || accounts[0];
                              derivationPath = account.derivationPath;
                              accountIdx = getAccountIdx(derivationPath);
                              _getPaths = getPaths(accountIdx), addressNList = _getPaths.addressNList;
                              _context7.next = 8;
                              return keepKeyWallet.ethSignMessage({
                                addressNList: addressNList,
                                message: message.slice(0, 2) === '0x' ? // @ts-ignore - commonjs weirdness
                                (ethUtil.default || ethUtil).toBuffer(message).toString('utf8') : message
                              });

                            case 8:
                              _yield$keepKeyWallet$ = _context7.sent;
                              signature = _yield$keepKeyWallet$.signature;
                              return _context7.abrupt("return", signature);

                            case 11:
                            case "end":
                              return _context7.stop();
                          }
                        }
                      }, _callee7);
                    }));

                    return function signMessage(_x5, _x6) {
                      return _ref13.apply(this, arguments);
                    };
                  }();

                  keepKeyProvider = getHardwareWalletProvider(function () {
                    return currentChain.rpcUrl;
                  });
                  provider = createEIP1193Provider(keepKeyProvider, {
                    eth_requestAccounts: function () {
                      var _eth_requestAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                        var name, accounts;
                        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                          while (1) {
                            switch (_context8.prev = _context8.next) {
                              case 0:
                                if (keepKeyWallet && typeof keepKeyWallet.cancel === 'function') {
                                  // cancel any current actions on device
                                  keepKeyWallet.cancel();
                                }

                                _context8.prev = 1;
                                _context8.next = 4;
                                return keepKeyAdapter.pairDevice();

                              case 4:
                                keepKeyWallet = _context8.sent;
                                _context8.next = 16;
                                break;

                              case 7:
                                _context8.prev = 7;
                                _context8.t0 = _context8["catch"](1);
                                name = _context8.t0.name; // This error indicates that the keepkey is paired with another app

                                if (!(name === HDWalletErrorType.ConflictingApp)) {
                                  _context8.next = 14;
                                  break;
                                }

                                throw new ProviderRpcError({
                                  code: 4001,
                                  message: errorMessages[ERROR_BUSY]
                                });

                              case 14:
                                if (!(name === HDWalletErrorType.WebUSBCouldNotPair)) {
                                  _context8.next = 16;
                                  break;
                                }

                                throw new ProviderRpcError({
                                  code: 4001,
                                  message: errorMessages[ERROR_PAIRING]
                                });

                              case 16:
                                _context8.next = 18;
                                return getAccounts();

                              case 18:
                                accounts = _context8.sent;

                                if (!(!accounts || !Array.isArray(accounts))) {
                                  _context8.next = 21;
                                  break;
                                }

                                throw new Error('No accounts were returned from Keepkey device');

                              case 21:
                                if (accounts.length) {
                                  _context8.next = 23;
                                  break;
                                }

                                throw new ProviderRpcError({
                                  code: 4001,
                                  message: 'User rejected the request.'
                                });

                              case 23:
                                if (accounts[0].hasOwnProperty('address')) {
                                  _context8.next = 25;
                                  break;
                                }

                                throw new Error('The account returned does not have a required address field');

                              case 25:
                                return _context8.abrupt("return", [accounts[0].address]);

                              case 26:
                              case "end":
                                return _context8.stop();
                            }
                          }
                        }, _callee8, null, [[1, 7]]);
                      }));

                      function eth_requestAccounts() {
                        return _eth_requestAccounts.apply(this, arguments);
                      }

                      return eth_requestAccounts;
                    }(),
                    eth_selectAccounts: function () {
                      var _eth_selectAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                        var accounts;
                        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                          while (1) {
                            switch (_context9.prev = _context9.next) {
                              case 0:
                                _context9.next = 2;
                                return getAccounts();

                              case 2:
                                accounts = _context9.sent;
                                return _context9.abrupt("return", accounts.map(function (_ref14) {
                                  var address = _ref14.address;
                                  return address;
                                }));

                              case 4:
                              case "end":
                                return _context9.stop();
                            }
                          }
                        }, _callee9);
                      }));

                      function eth_selectAccounts() {
                        return _eth_selectAccounts.apply(this, arguments);
                      }

                      return eth_selectAccounts;
                    }(),
                    eth_accounts: function () {
                      var _eth_accounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
                        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                          while (1) {
                            switch (_context10.prev = _context10.next) {
                              case 0:
                                if (!(!accounts || !Array.isArray(accounts))) {
                                  _context10.next = 2;
                                  break;
                                }

                                throw new Error('No accounts were returned from Keepkey device');

                              case 2:
                                return _context10.abrupt("return", accounts[0].hasOwnProperty('address') ? [accounts[0].address] : []);

                              case 3:
                              case "end":
                                return _context10.stop();
                            }
                          }
                        }, _callee10);
                      }));

                      function eth_accounts() {
                        return _eth_accounts.apply(this, arguments);
                      }

                      return eth_accounts;
                    }(),
                    eth_chainId: function () {
                      var _eth_chainId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
                        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                          while (1) {
                            switch (_context11.prev = _context11.next) {
                              case 0:
                                return _context11.abrupt("return", currentChain && currentChain.id != undefined ? currentChain.id : '0x0');

                              case 1:
                              case "end":
                                return _context11.stop();
                            }
                          }
                        }, _callee11);
                      }));

                      function eth_chainId() {
                        return _eth_chainId.apply(this, arguments);
                      }

                      return eth_chainId;
                    }(),
                    eth_signTransaction: function () {
                      var _eth_signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(_ref15) {
                        var _ref15$params, transactionObject, account, derivationPath, address, addressNList, signer, populatedTransaction, _bigNumberFieldsToStr, to, value, nonce, gasLimit, gasPrice, maxFeePerGas, maxPriorityFeePerGas, data, gasData, txn, serialized, _yield$keepKeyWallet$2;

                        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                          while (1) {
                            switch (_context12.prev = _context12.next) {
                              case 0:
                                _ref15$params = _slicedToArray(_ref15.params, 1), transactionObject = _ref15$params[0];

                                if (!(!accounts || !Array.isArray(accounts) || !accounts.length)) {
                                  _context12.next = 3;
                                  break;
                                }

                                throw new Error('No account selected. Must call eth_requestAccounts first.');

                              case 3:
                                // Per the code above if accounts is empty or undefined then this line of code won't execute
                                // ∴ account must be defined here which is why it is cast without the 'undefined' type
                                account = !transactionObject || !transactionObject.hasOwnProperty('from') ? accounts[0] : accounts.find(function (account) {
                                  return account.address.toLocaleLowerCase() === transactionObject.from.toLocaleLowerCase();
                                });
                                derivationPath = account.derivationPath, address = account.address;
                                addressNList = bip32ToAddressNList(derivationPath);
                                signer = ethersProvider.getSigner(address);
                                transactionObject.gasLimit = transactionObject.gas || transactionObject.gasLimit; // 'gas' is an invalid property for the TransactionRequest type

                                delete transactionObject.gas;
                                transactionObject.gasLimit = undefined;
                                _context12.next = 12;
                                return signer.populateTransaction(transactionObject);

                              case 12:
                                populatedTransaction = _context12.sent;
                                _bigNumberFieldsToStr = bigNumberFieldsToStrings(populatedTransaction), to = _bigNumberFieldsToStr.to, value = _bigNumberFieldsToStr.value, nonce = _bigNumberFieldsToStr.nonce, gasLimit = _bigNumberFieldsToStr.gasLimit, gasPrice = _bigNumberFieldsToStr.gasPrice, maxFeePerGas = _bigNumberFieldsToStr.maxFeePerGas, maxPriorityFeePerGas = _bigNumberFieldsToStr.maxPriorityFeePerGas, data = _bigNumberFieldsToStr.data;
                                gasData = gasPrice ? {
                                  gasPrice: gasPrice
                                } : {
                                  maxFeePerGas: maxFeePerGas,
                                  maxPriorityFeePerGas: maxPriorityFeePerGas
                                };
                                txn = _objectSpread({
                                  addressNList: addressNList,
                                  chainId: parseInt(currentChain.id),
                                  to: to || '',
                                  value: value || '',
                                  nonce: utils.hexValue(nonce),
                                  gasLimit: gasLimit || '0x0',
                                  data: (data || '').toString()
                                }, gasData);
                                _context12.prev = 16;
                                ;
                                _context12.next = 20;
                                return keepKeyWallet.ethSignTx(txn);

                              case 20:
                                _yield$keepKeyWallet$2 = _context12.sent;
                                serialized = _yield$keepKeyWallet$2.serialized;
                                _context12.next = 31;
                                break;

                              case 24:
                                _context12.prev = 24;
                                _context12.t0 = _context12["catch"](16);

                                if (!(_context12.t0.message && _context12.t0.message.message)) {
                                  _context12.next = 30;
                                  break;
                                }

                                throw new Error(_context12.t0.message.message);

                              case 30:
                                throw new Error(_context12.t0);

                              case 31:
                                return _context12.abrupt("return", serialized);

                              case 32:
                              case "end":
                                return _context12.stop();
                            }
                          }
                        }, _callee12, null, [[16, 24]]);
                      }));

                      function eth_signTransaction(_x7) {
                        return _eth_signTransaction.apply(this, arguments);
                      }

                      return eth_signTransaction;
                    }(),
                    eth_sendTransaction: function () {
                      var _eth_sendTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref16) {
                        var baseRequest, params, signedTx, transactionHash;
                        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                          while (1) {
                            switch (_context13.prev = _context13.next) {
                              case 0:
                                baseRequest = _ref16.baseRequest, params = _ref16.params;
                                _context13.next = 3;
                                return provider.request({
                                  method: 'eth_signTransaction',
                                  params: params
                                });

                              case 3:
                                signedTx = _context13.sent;
                                _context13.next = 6;
                                return baseRequest({
                                  method: 'eth_sendRawTransaction',
                                  params: [signedTx]
                                });

                              case 6:
                                transactionHash = _context13.sent;
                                return _context13.abrupt("return", transactionHash);

                              case 8:
                              case "end":
                                return _context13.stop();
                            }
                          }
                        }, _callee13);
                      }));

                      function eth_sendTransaction(_x8) {
                        return _eth_sendTransaction.apply(this, arguments);
                      }

                      return eth_sendTransaction;
                    }(),
                    eth_sign: function () {
                      var _eth_sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref17) {
                        var _ref17$params, address, message;

                        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                          while (1) {
                            switch (_context14.prev = _context14.next) {
                              case 0:
                                _ref17$params = _slicedToArray(_ref17.params, 2), address = _ref17$params[0], message = _ref17$params[1];
                                return _context14.abrupt("return", signMessage(address, message));

                              case 2:
                              case "end":
                                return _context14.stop();
                            }
                          }
                        }, _callee14);
                      }));

                      function eth_sign(_x9) {
                        return _eth_sign.apply(this, arguments);
                      }

                      return eth_sign;
                    }(),
                    personal_sign: function () {
                      var _personal_sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(_ref18) {
                        var _ref18$params, message, address;

                        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                          while (1) {
                            switch (_context15.prev = _context15.next) {
                              case 0:
                                _ref18$params = _slicedToArray(_ref18.params, 2), message = _ref18$params[0], address = _ref18$params[1];
                                return _context15.abrupt("return", signMessage(address, message));

                              case 2:
                              case "end":
                                return _context15.stop();
                            }
                          }
                        }, _callee15);
                      }));

                      function personal_sign(_x10) {
                        return _personal_sign.apply(this, arguments);
                      }

                      return personal_sign;
                    }(),
                    eth_signTypedData: null,
                    wallet_switchEthereumChain: function () {
                      var _wallet_switchEthereumChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(_ref19) {
                        var _ref19$params, chainId;

                        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                          while (1) {
                            switch (_context16.prev = _context16.next) {
                              case 0:
                                _ref19$params = _slicedToArray(_ref19.params, 1), chainId = _ref19$params[0].chainId;
                                currentChain = chains.find(function (_ref20) {
                                  var id = _ref20.id;
                                  return id === chainId;
                                }) || currentChain;

                                if (currentChain) {
                                  _context16.next = 4;
                                  break;
                                }

                                throw new Error('chain must be set before switching');

                              case 4:
                                eventEmitter.emit('chainChanged', currentChain.id);
                                return _context16.abrupt("return", null);

                              case 6:
                              case "end":
                                return _context16.stop();
                            }
                          }
                        }, _callee16);
                      }));

                      function wallet_switchEthereumChain(_x11) {
                        return _wallet_switchEthereumChain.apply(this, arguments);
                      }

                      return wallet_switchEthereumChain;
                    }(),
                    wallet_addEthereumChain: null
                  });
                  provider.on = eventEmitter.on.bind(eventEmitter);
                  return _context17.abrupt("return", {
                    provider: provider,
                    instance: {
                      selectAccount: getAccounts
                    }
                  });

                case 51:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17);
        }));

        function getInterface(_x) {
          return _getInterface.apply(this, arguments);
        }

        return getInterface;
      }()
    };
  };
}

export default keepkey;